import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
 
export default (app:any) => {
  app.use(ElementPlus, {
	locale: zhCn,
  })
  app._context.components.ElDialog.props.closeOnClickModal.default = false
  app._context.components.ElDialog.props.closeOnPressEscape.default = false
  app._context.components.ElDrawer.props.closeOnClickModal.default = false
  app._context.components.ElDrawer.props.closeOnPressEscape.default = false
}